import * as React from 'react';
import { useSystem } from "src/hooks/system";

const DisplayQtyMinQtyMult = (props) => {
    const [,{ get_quantity_format }] = useSystem();
    const { single_product } = props;
    return (
        <>
            {single_product?.QtyMin > 0 && single_product?.QtyMult > 0 &&
                <>
                    <span className='min-mult-labal'>Min:</span>{get_quantity_format(single_product.QtyMin)} &nbsp;
                    <span className='min-mult-labal'>Mult:</span>{get_quantity_format(single_product.QtyMult)} &nbsp;
                </>
            }
        </>
    );
}

export default DisplayQtyMinQtyMult;